/* Browser-local favourites; no customer or account data is stored. */
(() => {
  'use strict';
  if (window.SJFavourites) { window.SJFavourites.refresh(); return; }
  const key = 'sj-favourites-v1';
  const valid = value => typeof value === 'string' && /^[a-z0-9][a-z0-9-]{0,254}$/.test(value);
  const parse = value => {
    try { const list = JSON.parse(value || '[]'); return new Set(Array.isArray(list) ? list.filter(valid).slice(0,250) : []); }
    catch (_) { return new Set(); }
  };
  let saved = new Set();
  let persistent = true;
  try { saved = parse(localStorage.getItem(key)); } catch (_) { persistent = false; }
  function refresh() {
    document.querySelectorAll('[data-sj-favourite]').forEach(button => {
      const active = saved.has(button.dataset.sjFavourite);
      button.setAttribute('aria-pressed', String(active));
      const icon = button.querySelector('svg');
      if (icon) icon.setAttribute('fill', active ? 'currentColor' : 'none');
    });
    document.querySelectorAll('[data-sj-favourites]').forEach(root => {
      let count = 0;
      root.querySelectorAll('[data-sj-favourite-card]').forEach(card => {
        card.hidden = !saved.has(card.dataset.sjFavouriteCard);
        if (!card.hidden) count++;
      });
      const empty = root.querySelector('[data-sj-favourites-empty]');
      const total = root.querySelector('[data-sj-favourites-count]');
      if (empty) empty.hidden = count > 0;
      if (total) total.textContent = String(count);
    });
    document.querySelectorAll('[data-sj-favourites-storage]').forEach(node => { node.hidden = persistent; });
  }
  function save() {
    try { localStorage.setItem(key, JSON.stringify([...saved])); persistent = true; }
    catch (_) { persistent = false; }
  }
  document.addEventListener('click', event => {
    const button = event.target.closest('[data-sj-favourite], [data-sj-favourite-remove]');
    if (!button) return;
    const handle = button.dataset.sjFavourite || button.dataset.sjFavouriteRemove;
    if (!valid(handle)) return;
    event.preventDefault();
    if (button.hasAttribute('data-sj-favourite-remove') || saved.has(handle)) saved.delete(handle);
    else if (saved.size < 250) saved.add(handle);
    save();
    if (button.hasAttribute('data-sj-favourite-remove')) {
      const root = button.closest('[data-sj-favourites]');
      const focusTarget = root && root.querySelector('[data-sj-favourites-heading]');
      if (focusTarget) focusTarget.focus();
    }
    refresh();
  });
  window.addEventListener('storage', event => { if (event.key === key || event.key === null) { saved = parse(event.newValue); refresh(); } });
  window.addEventListener('pageshow', () => {
    try { saved = parse(localStorage.getItem(key)); persistent = true; } catch (_) { persistent = false; }
    refresh();
  });
  document.addEventListener('shopify:section:load', refresh);
  window.SJFavourites = { refresh };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', refresh, { once:true });
  else refresh();
})();
